<div class="content client-list">
  <div class="content-body">
    <app-transactions-header
      (triggerDataFromHeader)="getDataFromHeader($event)"
      [listParameters]="listParameters"
    >
    </app-transactions-header>
    <div class="alert-message mb-10" *ngIf="isViewPermission$ | async">
      <mat-icon class="material-icons-outlined">error_outline</mat-icon>
      {{ commonNotificationText.ViewOnlyAccessMessage }}
    </div>
    <div class="mat-table-wrapper">
      <table
        aria-describedby="buld-edit-List"
        mat-table
        [dataSource]="bulkEditList"
      >
        <ng-container matColumnDef="srNo">
          <th mat-header-cell *matHeaderCellDef class="w-20 pr-0">
            <mat-checkbox
              [(ngModel)]="isAllSelected"
              (change)="selectAll($event)"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element" class="pr-0">
            <div class="d-flex">
              <mat-checkbox
                [(ngModel)]="element.isSelected"
                (change)="onCheckBoxChanges($event, element)"
                [disabled]="element.isPeriodLocked"
              >
              </mat-checkbox>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef class="w-100">Date</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex white-space-nowrap">
              {{ element.date | date: "dd-LLL-yyyy" }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="reference">
          <th mat-header-cell *matHeaderCellDef>Reference</th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field class="wp-100">
              <input
                matInput
                [(ngModel)]="element.reference"
                autocomplete="off"
                [disabled]="(isViewPermission$ | async) || element.isPeriodLocked"
              />
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="account">
          <th mat-header-cell *matHeaderCellDef class="w-200">Account</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex">
                <ng-select class="w-170"
          #fundName
          (focus)="fundName.open()"
           [(ngModel)]="element.accountValue"
          [disabled]="(isViewPermission$ | async) || element.isPeriodLocked"
         panelClass="myPanelClass w-170"
        >
          <ng-option  *ngFor="let account of accountList" [value]="account.id">
            <div class="clamp" title=" {{ account.name }}">{{ account.name }}</div>
          </ng-option>
        </ng-select>
             
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="fund">
          <th mat-header-cell *matHeaderCellDef class="w-200">Fund</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex">
              <ng-select class="w-170"
        [(ngModel)]="element.fundId"
                  [disabled]="(isViewPermission$ | async) || element.isPeriodLocked"
         panelClass="myPanelClass w-170"
        >
          <ng-option   *ngFor="let fund of fundList"
                    [value]="fund.id">
             {{ fund.name }}
          </ng-option>
        </ng-select>
              
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="contactName">
          <th mat-header-cell *matHeaderCellDef><span class="white-space-nowrap">Contact Name</span></th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex white-space-nowrap">
              {{ element.contactName }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="referenceNo">
          <th mat-header-cell *matHeaderCellDef><span class="white-space-nowrap">Ref. No.</span></th>
          <td mat-cell *matCellDef="let element">
            <a *ngIf="element.moduleId !== 34 "
              class="link fw-bold white-space-nowrap"
              href="javascript:void()"
              (click)="onInvoiceClick(element)"
            >
              {{ element.referenceNo }}</a
            ><span *ngIf="element.moduleId === 34 "
            class="fw-bold white-space-nowrap"
          >
            {{ element.referenceNo }}</span
          >
          </td>
        </ng-container>
        <ng-container matColumnDef="receipt">
          <th mat-header-cell *matHeaderCellDef class="text-align-right">
            Reciept
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex justify-content-end white-space-nowrap" *ngIf="element.receipt > 0">
              £ {{ element.receipt }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="payment">
          <th mat-header-cell *matHeaderCellDef class="text-align-right">
            Payment
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex justify-content-end" *ngIf="element.payment > 0">
              £ {{ element.payment }}
            </div>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayBulkEditColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayBulkEditColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td
            class="mat-cell"
            [ngClass]="'text-align-center'"
            [attr.colspan]="displayBulkEditColumns.length"
          >
            <span *ngIf="listParameters">No records found</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <app-buttons
    *ngIf="isRecordSelected && !(isViewPermission$ | async)"
    [getModuleId]="moduleId"
    (triggerOnSaveClick)="onSave($event.isExit)"
  ></app-buttons>
</div>
